export default __webpack_public_path__ + "static/ThomasDunstan-Resume-2021-5f034208b1b906dcbb952edf56f2fe5a.pdf";